import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/yamaha-logo.png"; // update this path as needed

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-blue-800 text-white shadow">
      <div className="max-w-7xl mx-auto flex justify-between items-center px-4 py-4">
        {/* Logo and Title */}
        <Link to="/" className="flex items-center space-x-3">
          <img src={logo} alt="Yamaha Logo" className="h-10 w-auto" />
          <h1 className="text-xl font-bold">Excellent Yamaha</h1>
        </Link>

        {/* Hamburger for mobile */}
        <button
          className="md:hidden focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {menuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Menu links */}
        <nav
          className={`${
            menuOpen ? "block" : "hidden"
          } absolute top-full left-0 w-full bg-blue-800 text-center md:static md:flex md:w-auto md:bg-transparent md:space-x-6 py-4 md:py-0 space-y-2 md:space-y-0`}
        >
          <Link
            to="/"
            className="block md:inline hover:text-yellow-400 px-4"
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/offers"
            className="block md:inline hover:text-yellow-400 px-4"
            onClick={() => setMenuOpen(false)}
          >
            Offers
          </Link>
          <Link
            to="/models"
            className="block md:inline hover:text-yellow-400 px-4"
            onClick={() => setMenuOpen(false)}
          >
            Models
          </Link>
          <Link
            to="/locate-us"
            className="hover:text-yellow-400 px-4 block md:inline"
            onClick={() => setMenuOpen(false)}
          >
            Locate Us
          </Link>
          <Link
            to="/contact"
            className="block md:inline hover:text-yellow-400 px-4"
            onClick={() => setMenuOpen(false)}
          >
            Contact
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
